import { render } from "./S97330.vue?vue&type=template&id=08aa22e8"
const script = {}
script.render = render

export default script